import { render, staticRenderFns } from "./PortfolioHome.vue?vue&type=template&id=bd551358&scoped=true&"
import script from "./PortfolioHome.vue?vue&type=script&lang=js&"
export * from "./PortfolioHome.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioHome.vue?vue&type=style&index=0&id=bd551358&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd551358",
  null
  
)

export default component.exports